<template>
  <rmp-base-modal
    v-model="isOpen"
    extra-classes="BorderedHeaderModal"
  >
    <template #modal-header>
      <h2 class="u-text-center">
        Duplicate Event
      </h2>
    </template>
    <template #modal-body>
      <div class="Notice Notice--warning DuplicateForm">
        <h3 class="Notice-header">
          Please read carefully
        </h3>
        <p>You are going to duplicate the event named:</p>
        <ul>
          <li><b>{{ event.name }} </b></li>
        </ul>
        <p class="Notice-copy">
          The following information will be carried over:
        </p>
        <ul>
          <li>Basic Info</li>
          <li>Branding (eg: form header image)</li>
          <li>Theme</li>
          <li>Questions</li>
          <li v-if="isDynamicForm()">
            Logic \ Screen Flow
          </li>
          <li v-if="isDynamicForm()">
            Logic \ Scores
          </li>
          <li>Messages</li>
          <li>Automations</li>
          <li>Integrations</li>
        </ul>
        <p>Records won't be carried over.</p>
      </div>
      <div class="DuplicateFormSettings" />
      <rmp-input
        v-model.trim="fields.eventName"
        label="Event Name"
        placeholder="Enter the name of the new event"
      />
    </template>
    <template #modal-footer>
      <div class="u-floatLeft">
        <button
          class="Button Button--green-outline"
          @click="isOpen = false"
        >
          Cancel
        </button>
      </div>
      <div class="u-floatRight">
        <button
          :disabled="fields.eventName.length === 0"
          :class="[{'is-loading': ui.submitLoading }, 'Button Button--green']"
          @click="handleDuplicateEvent"
        >
          Duplicate Event
        </button>
      </div>
    </template>
  </rmp-base-modal>
</template>
<script>
import { mapActions } from 'vuex';
import RmpBaseModal from '@rmpenterprise/base-modal';
import RmpInput from '@rmpenterprise/form-input';
import ModalActionsMixin from './mixins/modal-actions-mixin';

export default {
  components: { RmpBaseModal, RmpInput },
  mixins: [ModalActionsMixin],
  props: {
    event: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      fields: {
        eventName: '',
      },
      ui: {
        submitLoading: false,
      },
    };
  },
  methods: {
    ...mapActions('events', ['duplicateEvent']),
    isDynamicForm() {
      return this.event.type === 'dynamic';
    },
    handleDuplicateEvent() {
      this.ui.submitLoading = true;
      const payload = {
        eventName: this.fields.eventName,
      };
      this.duplicateEvent({ eventId: this.event.id, payload })
        .then(({ data }) => {
          this.ui.submitLoading = false;
          this.isOpen = false;
          this.fields.eventName = '';
          this.$emit('duplicate-event:success');
          this.$bus.$emit('displayMsg', {
            text: data.data.message,
            type: 'success',
          });
          setTimeout(() => {
            this.$router.push({ name: 'events-index' });
          }, 2000);
        })
        .catch(({ data }) => {
          this.ui.submitLoading = false;
          this.$bus.$emit('global-dismiss-modal'); // Dismiss modal
          let { message } = data.data;
          if (data.message) {
            message = data.message;
          }
          this.$bus.$emit('displayMsg', {
            text: message,
            type: 'error',
          });
        });
    },
  },
};
</script>
<style lang="less" scoped>

.DuplicateForm {

  h3 {
    text-align: center;
  }

  p, ul, li {
    color: #a94442;
  }

  ul {
    list-style: disc;
    margin-left: 15px;
  }
}

::v-deep .Form-label {
  margin-bottom: 8px !important;
}

.BorderedHeaderModal {
  .Notice {
    margin-bottom: 25px;
  }

  .Form-field {
    margin-bottom: 0;
  }
}
</style>
